 export const styles = {
    card:{
        background:"transparent",
        fontFamily:"Montserrat, sans-serif",
        boxShadow:"none",
        position:"absolute",
        overflow:"hidden",
        width:"230px",
        height:"350px",

        border: 'none',
        borderColor: 'transparent',
        borderStyle: 'solid !important',
        borderWidth: 'thick !important',
        borderRadius: 'var(--card-border-radius) !important',

        '&[data-card-selected="true"]': {
            borderColor: 'var(--card-border-colour) !important',
        },
        '& *': {
            boxSizing: 'border-box',
        },
    },

    n_card:{
        background:"transparent",
        fontFamily:"Montserrat, sans-serif",
        boxShadow:"none",
        position:"relative",
        overflow:"hidden",
        marginBottom:"-280px",
        width:"230px",
        height:"350px",
        borderRadius:"10px",
    },

    deck_card: {
        background:"transparent",
        fontFamily:"Montserrat, sans-serif",
        boxShadow:"none",
        position:"relative",
        overflow:"hidden",
        marginBottom:"-355px",
        width:"230px",
        height:"350px",
        borderRadius:"10px",
    },


    /* Content face — white frame (outline), inset coloured panel inside */
    cardContent:{
        position:"absolute",
        height:"calc(100%)",
        width:"100%",
        padding:"6px",
        top:"0",
        left:"0",
        background:"#FFF",
        transition:"0.5s",
        transformStyle:"preserve-3d",
        transform:"rotateY(0deg)",
        border:"0.5px solid #c4c4c4",
        borderRadius:"12px",
        opacity:1,
        zIndex:1
    },

    cardContentFlip:{
        position:"absolute",
        height:"calc(100%)",
        width:"100%",
        padding:"6px",
        background:"#FFF",
        top:"0",
        left:"0",
        transition:"0.5s",
        transformStyle:"preserve-3d",
        transform:"rotateY(180deg)",
        border:"0.5px solid #c4c4c4",
        borderRadius:"12px",
        opacity:0,
        zIndex:0
    },

    /* Inset coloured panel that holds header / body / footer */
    cardInnerPanel:{
        position:"relative",
        height:"100%",
        width:"100%",
        borderRadius:"8px",
        overflow:"hidden",
        display:"flex",
        flexDirection:"column",
    },

    cardHeaderRow:{
        display:"flex",
        alignItems:"center",
        justifyContent:"space-between",
        padding:"10px 12px 2px 12px",
        flexShrink:0,
        position:"relative",
        zIndex:3,
    },

    cardHeaderLeft:{
        display:"flex",
        alignItems:"center",
        minWidth:0,
    },

    cardTitle:{
        flex:1,
        minWidth:0,
        textAlign:"center",
        fontSize:"16px",
        fontWeight:"bold",
        margin:"0 6px",
        whiteSpace:"nowrap",
        overflow:"hidden",
        textOverflow:"ellipsis",
    },

    cardHeaderMenuBtn:{
        padding:"2px",
        width:"28px",
        height:"28px",
        flexShrink:0,
        '&:focus':{
            outline:"none",
        },
    },

    cardFooter:{
        position:"absolute",
        bottom:0,
        left:0,
        right:0,
        padding:"6px 12px 10px 12px",
        fontSize:"13px",
        fontWeight:"normal",
        zIndex:3,
        whiteSpace:"nowrap",
        overflow:"hidden",
        textOverflow:"ellipsis",
    },

    iconRight:{
        float:"right",
        '&:focus':{
            outline:"none"
        }
    },

    sendRight:{
        float:"right",
        color:"#4173D6",
        opacity:1,
        '&:focus':{
            outline:"none"
        }
    },

    sendRightHide:{
        float:"right",
        color:"#4173D6",
        opacity:0
    },

    contentWrapper:{
        position:"relative",
        margin:0,
        marginTop:"7px",
        minWidth:0,
        flex:1,
        overflow:"hidden",
    },

    content:{
        width:"100%",
        fontFamily:"Inter",
        fontWeight:"500",
        padding:"4px 12px 30px 12px",
        '&:focus':{
            outline: "0px solid transparent",
        },
        overflowWrap: "break-word",
        wordWrap: "break-word",
    },

    /* Full-bleed image: fills the body edge-to-edge, down over the footer, inside the outline */
    imgFill:{
        position:"absolute",
        top:0,
        left:0,
        right:0,
        bottom:0,
        overflow:"hidden",
        zIndex:1,
        "&:hover $imgDelete":{
            background:"rgba(0,0,0, 0.7)",
            color:"white"
        }
    },

    counterShow:{
        display:"inline-block",
        fontSize:"14px",
        margin:"0",
        marginTop:"0px",
        opacity:1,
        color:"#C4C4C4"
    },

    counterHide:{

        opacity:0
    },

    username:{
        fontSize:"14px",
        margin:"0",
        fontWeight:"bold"
    },

    pin:{
        fontSize:"12px",
        marginLeft:"2px",
        marginTop:"2px"
    },
    /* Back Card Cover */
    cardCover:{
        position:"absolute",
        height:"calc(100%)",
        width:"100%",
        padding:"6px",
        transition:"0.5s",
        top:"0",
        left:"0",
        background:"#FFF",
        opacity:1,
        transformStyle:"preserve-3d",
        transform:"rotateY(180deg)",
        border:"0.5px solid #c4c4c4",
        borderRadius:"12px",
        zIndex:0
    },

    cardCoverFlip:{
        position:"absolute",
        height:"calc(100%)",
        width:"100%",
        padding:"6px",
        top:"0",
        left:"0",
        transition:"0.5s",
        background:"#FFF",
        opacity: 1,
        transformStyle:"preserve-3d",
        transform:"rotateY(0deg)",
        border:"0.5px solid #c4c4c4",
        borderRadius:"12px",
        zIndex:1
    },

    cardCoverIconWrapper:{
        margin:"40px 0",
    },

    cardCoverHero:{
        flex:1,
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
    },

    cardCoverCategory:{
        fontSize:"18px",
        textAlign:"center",
        fontWeight:"bold"
    },

    cardCoverInfo:{
        fontSize:"14px",
        textAlign:"center"
    },

    /* Menu */
    menuIcon:{
        marginRight:"5px"
    },

    '@keyframes deleteConfirmSlideIn':{
        from:{
            opacity:0,
            transform:"translateX(12px)"
        },
        to:{
            opacity:1,
            transform:"translateX(0)"
        }
    },

    menuItemDeleteConfirm:{
        backgroundColor:"#DC3220 !important",
        color:"#fff !important",
        animation:"$deleteConfirmSlideIn 0.25s ease-out",
        '& $menuIcon':{
            color:"#fff"
        },
        '&:hover':{
            backgroundColor:"#c22a1a !important"
        }
    },

    imgHolder:{
        position:"relative",
        width:"100%",
        height:"170px",
        overflow:"hidden",
        "&:hover $imgDelete":{
            background:"rgba(0,0,0, 0.7)",
            color:"white"
        }
    },

    imgDelete:{
        position:"absolute",
        right:"5px",
        top:"5px",
        width:"20px",
        outline:"none",
        height:"20px",
        background:"transparent",
        color:"transparent",
        zIndex:"2",
        transition:"0.5s",
    },

    dropZone:{
        width:"100%",
        height:"170px",
        border:"1px dashed #C4C4C4",
        background:"#F2F2F2",
        color:"#C4C4C4",
        lineHeight: "160px",
        fontSize:"12px",
        fontFamily:"Montserrat",
        textAlign:"center"
    },
    draggableStackContainer: {
        border: 'none',
        borderColor: 'transparent',
        borderStyle: 'solid !important',
        borderWidth: 'thick !important',
        borderRadius: 'var(--card-border-radius) !important',
        overflow: 'hidden',
    },
    draggableStackContainerSelected: {
        borderColor: 'var(--card-border-colour) !important',
    },
    arrowLeftPairOverlay:{
        backgroundColor: 'grey',
        borderRadius: '25px',
        position: 'absolute',
        top: '160px',
        left: '-10px',
        zIndex: '1000',
        color: 'white',
        width: '35px',
        height: '35px',
    },
    arrowRightPairOverlay:{
        backgroundColor: 'grey',
        borderRadius: '25px',
        position: 'absolute',
        top: '160px',
        left: '210px',
        zIndex: '1000',
        color: 'white',
        width: '35px',
        height: '35px',
    },
    arrowUpPairOverlay:{
        backgroundColor: 'grey',
        borderRadius: '25px',
        position: 'absolute',
        top: '-8px',
        left: '105px',
        zIndex: '1000',
        color: 'white',
        width: '35px',
        height: '35px',
    },
    arrowDownPairOverlay:{
        backgroundColor: 'grey',
        borderRadius: '25px',
        position: 'absolute',
        top: '325px',
        left: '105px',
        zIndex: '1000',
        color: 'white',
        width: '35px',
        height: '35px',
    },

}

export default styles;
